export default {
    forgot_password_title: "Recuperar contraseña",
    forgot_password_id: "Número de cédula",
    forgot_password_login: "Regresar a iniciar sesión",
    forgot_password_error_message: "Se ha enviado un código de seguridad a la dirección de correo eléctronica registrada para recuperar contraseña",
}